(() => {
  const gallery = document.querySelector('[data-casekoo-standkoo-gallery]');
  if (!gallery) return;
  const productSection = gallery.closest('.shopify-section');
  const main = productSection?.parentElement;
  if (!productSection || !main) return;

  const laterSections = [...main.children].filter((element) =>
    element instanceof HTMLElement
    && element.classList.contains('shopify-section')
    && element !== productSection
    && Boolean(productSection.compareDocumentPosition(element) & Node.DOCUMENT_POSITION_FOLLOWING)
  );

  laterSections.forEach((section) => section.classList.add('casekoo-deferred-section'));

  const deferredSlideshows = laterSections.flatMap((section) => [...section.querySelectorAll('.splide')]);
  deferredSlideshows.forEach((slideshow) => slideshow.setAttribute('data-casekoo-defer-slideshow', ''));

  if ('IntersectionObserver' in window) {
    const slideshowObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        const slideshow = entry.target;
        slideshow.setAttribute('data-casekoo-defer-ready', '');
        window.makeSlideshow?.(slideshow);
        slideshowObserver.unobserve(slideshow);
      });
    }, { rootMargin: '100% 0px', threshold: 0.01 });
    deferredSlideshows.forEach((slideshow) => slideshowObserver.observe(slideshow));
  } else {
    deferredSlideshows.forEach((slideshow) => {
      slideshow.setAttribute('data-casekoo-defer-ready', '');
      window.makeSlideshow?.(slideshow);
    });
  }

  const prepareVideo = (video) => {
    if (!(video instanceof HTMLVideoElement) || video.dataset.casekooVideoReady === 'true') return;
    video.dataset.casekooVideoReady = 'true';
    const wantsAutoplay = video.autoplay || video.hasAttribute('autoplay');
    video.preload = 'none';
    video.pause();

    const hydrateSources = () => {
      let changed = false;
      video.querySelectorAll('source[data-src]').forEach((source) => {
        if (!source.src) {
          source.src = source.dataset.src;
          changed = true;
        }
        source.removeAttribute('data-src');
      });
      if (video.dataset.src && !video.src) {
        video.src = video.dataset.src;
        video.removeAttribute('data-src');
        changed = true;
      }
      if (changed) video.load();
    };

    const nearObserver = new IntersectionObserver((entries) => {
      if (entries.some((entry) => entry.isIntersecting)) {
        hydrateSources();
        nearObserver.disconnect();
      }
    }, { rootMargin: '150% 0px', threshold: 0.01 });
    nearObserver.observe(video);

    const playObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting && entry.intersectionRatio >= 0.25) {
          hydrateSources();
          if (wantsAutoplay) video.play().catch(() => {});
        } else {
          video.pause();
        }
      });
    }, { threshold: [0, 0.25, 0.6] });
    playObserver.observe(video);
  };

  laterSections.forEach((section) => {
    section.querySelectorAll('video').forEach((video) => {
      if (video.closest('[data-ck-standkoo-life], ck-frost-comparison')) return;
      prepareVideo(video);
    });
  });
})();
